import { IStaffItem } from "@/types/share";
import Checkbox from "@/component/Checkbox";
import StaffItem from "./StaffItem";
import { Loading, LoadMore } from "@/component/Loading";
import IC_RETRY from "@/assets/record/ic_retry.svg?react";
import IC_NO_STAFF from "@/assets/common/ic_no_staff.png";
import IC_NODE from "@/assets/common/ic_none.png";
import "./index.css";
interface StaffListProps {
  staffList: IStaffItem[];
  showLoadMore: boolean;
  isLoading: boolean;
  loadError: boolean;
  keyword: string;
  retry: () => void;
  handleChoose: (identityId: string, value: boolean) => void;
  onListScroll: (e: React.UIEvent<HTMLDivElement>) => void;
}

const StaffList = ({
  staffList,
  showLoadMore,
  isLoading,
  loadError,
  keyword,
  handleChoose,
  onListScroll,
  retry,
}: StaffListProps) => {
  return (
    <>
      {loadError ? (
        <div className="flex flex-col flex-justify-center flex-items-center flex-1">
          <IC_RETRY className="w-20 h-20" />
          <span className="mt-1 text-mx-quaternary text-3.5">加载超时</span>
          <div
            className="mt-4 b-1 border-solid b-#DBDEE4 w-22 h-8 rounded-1.5 flex justify-center items-center text-mx-secondary text-3.5 cursor-pointer"
            onClick={retry}
          >
            重试
          </div>
        </div>
      ) : isLoading ? (
        <div className="flex-1 flex items-center justify-center">
          <Loading />
        </div>
      ) : staffList.length === 0 ? (
        <div className="flex flex-col flex-justify-center flex-items-center flex-1">
          <img src={keyword ? IC_NO_STAFF : IC_NODE} className="w-20 h-20" />
          <span className="mt-4 h-5 lh-5 text-mx-quaternary text-3.5">
            {keyword ? "未能找到相关结果" : "暂无记录"}
          </span>
        </div>
      ) : (
        <div
          className="mx-4 overflow-auto text-3.5 text-#30343C my-scrollbar"
          onScroll={(e) => {
            onListScroll(e);
          }}
        >
          {staffList.map((staff, index) => {
            return (
              <div
                key={staff.identityId}
                className="flex items-center h-12 hover:bg-#F4F6F9 rd-2 pl-2"
              >
                <Checkbox
                  checked={staff.subscribed}
                  onChange={(e) => {
                    handleChoose(staff.identityId, e.target.checked);
                  }}
                  disabled={staff.disabled}
                  wrapperClassName="staff-checkbox"
                >
                  <div className="pl-2">
                    <StaffItem staff={staff} index={index} />
                  </div>
                </Checkbox>
              </div>
            );
          })}
          {showLoadMore && <LoadMore />}
        </div>
      )}
    </>
  );
};

export default StaffList;
